import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';

const variants = {
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
  tap: {
    scale: 0.95,
  },
};

export function Button({ text, to, className, variant = 'primary', size = 'md', ...props }) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black';
  
  const variants = {
    primary: 'bg-primary-500 text-white hover:bg-primary-600 focus:ring-primary-500',
    secondary: 'bg-secondary-500 text-white hover:bg-secondary-600 focus:ring-secondary-500',
    outline: 'border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white focus:ring-primary-500',
    ghost: 'text-gray-300 hover:text-white hover:bg-gray-800 focus:ring-gray-500',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  const buttonStyles = clsx(
    baseStyles,
    variants[variant],
    sizes[size],
    className
  );

  if (to) {
    return (
      <motion.div
        whileHover="hover"
        whileTap="tap"
        variants={variants}
      >
        <Link
          to={to}
          className={buttonStyles}
          {...props}
        >
          {text}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button
      whileHover="hover"
      whileTap="tap"
      variants={variants}
      className={buttonStyles}
      {...props}
    >
      {text}
    </motion.button>
  );
}